import React from "react";
import { Sparkles } from "lucide-react";

// The panel that opens an article.
//
// Its contents are decided in blogContent.js: an author-written excerpt where
// one exists, otherwise the post's own opening paragraph, lifted out of the
// body so it is not printed twice. Nine of the thirteen posts fall into the
// second case, which is why this used to appear on only four of them.
const BlogSummary = ({ html }) => {
  if (!html) return null;

  return (
    <aside
      aria-label="Article summary"
      className="relative mb-10 overflow-hidden rounded-2xl border border-[#dfeadf] bg-gradient-to-br from-[#f3f9f3] to-[#eef6ee] p-5 pl-6 sm:p-7 sm:pl-8"
    >
      {/* A solid rule down the left edge rather than a full border in a
          heavier colour: it marks the block as an aside without boxing the
          text in, which at this width starts to read as a warning. */}
      <span
        aria-hidden="true"
        className="absolute inset-y-0 left-0 w-[5px] bg-[#117816]"
      />

      <div className="mb-3 flex items-center gap-2">
        <span className="grid h-7 w-7 place-items-center rounded-full bg-[#117816]/10 text-[#117816]">
          <Sparkles size={15} aria-hidden="true" />
        </span>
        <p className="text-[12px] font-bold uppercase tracking-[0.16em] text-[#117816]">
          In short
        </p>
      </div>

      <div
        className="blog-summary text-[15px] leading-[1.75] text-[#374151] sm:text-[16px] sm:leading-[1.8]"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </aside>
  );
};

export default BlogSummary;
